import * as React from "react";
import { Select } from "antd";
import { ModeOption } from "antd/lib/select";

const Option = Select.Option;

interface IProps {
	// passed props
	onChange: (e: any) => void;
	onSearch?: (e: any, options?: any) => void;
	dropDownConfiguration?: IDropDownConfiguration;
	pickListStore: IPickListStore;
	value: number | number[];
	specifiedOptions?: PickListItemResponseDTO[];
	configuration: {
		placeholder?: string;
		id?: string;
		name?: string;
		pickListCode?: string;
		mode?: ModeOption;
		required?: boolean;
		parentCode?: string;
		disabled?: boolean;
	};
}

interface IDropDownConfiguration {
	name?: string;
	className?: string;
	required?: boolean;
	placeholder: string;
	mode?: ModeOption;
	disabled?: boolean;
	sort?: boolean;
	pickListCode?: string;
	optionFilterProps?: string;
	parentCode?: string;
	labelInValue?: boolean;
	showArrow?: boolean;
	showSearch?: boolean;
	id?: string;
}

interface IPickListStore {
	pickListItems: PickListItemResponseDTO[];
	pickListTypes: PickListType[];
}

export const DropdownInputAnt: React.FC<IProps> = ({
	specifiedOptions,
	value,
	pickListStore,
	onChange,
	configuration,
	dropDownConfiguration = {
		placeholder: configuration!.placeholder || "choose a value",
		labelInValue: true,
		showArrow: true,
		showSearch: true,
		optionFilterProps: "children",
		mode: configuration!.mode,
		id: configuration!.id,
		name: configuration!.name,
		pickListCode: configuration!.pickListCode,
		required: configuration!.required,
		parentCode: configuration!.parentCode,
		disabled: configuration!.disabled,
	},
}) => {
	if (!isUndefinedOrEmpty(specifiedOptions)) {
		const options = filterSpecifiedOptions(specifiedOptions!);
		const selectValue = setValue(
			value,
			pickListStore.pickListItems,
			dropDownConfiguration.pickListCode!
		);
		return (
			<Select
				value={selectValue}
				mode={dropDownConfiguration.mode}
				placeholder={dropDownConfiguration.placeholder!}
				showSearch={dropDownConfiguration.showSearch}
				disabled={dropDownConfiguration.disabled}
				labelInValue={dropDownConfiguration.labelInValue}
				className={dropDownConfiguration.className}
				optionFilterProp={dropDownConfiguration.optionFilterProps}
				onChange={onChange}
				// filterOption={(input: string, option: any) => option.props.children.includes(input)}
				// onSearch={(e: any) => props.onSearch(e, options)}
			>
				{options}
			</Select>
		);
	}

	if (!isUndefinedOrEmptyString(dropDownConfiguration.parentCode)) {
		const options = filterPickListItemsByParentCode(
			pickListStore.pickListItems,
			dropDownConfiguration.parentCode!,
			dropDownConfiguration.pickListCode!
		);
		const selectValue = setValue(
			value,
			pickListStore.pickListItems,
			dropDownConfiguration.pickListCode!
		);
		return (
			<Select
				value={selectValue}
				mode={dropDownConfiguration.mode}
				placeholder={dropDownConfiguration.placeholder}
				showSearch={dropDownConfiguration.showSearch}
				disabled={dropDownConfiguration.disabled}
				labelInValue={dropDownConfiguration.labelInValue}
				className={dropDownConfiguration.className}
				optionFilterProp={dropDownConfiguration.optionFilterProps}
				onChange={onChange}
				// filterOption={(input: string, option: any) => option.props.children.includes(input)}
				// onSearch={(e: any) => props.onSearch(e, options)}
			>
				{options}
			</Select>
		);
	} else {
		const options = filterPickListItemsWithoutParentCode(
			pickListStore.pickListItems,
			dropDownConfiguration.pickListCode!
		);
		const selectValue = setValue(
			value,
			pickListStore.pickListItems,
			dropDownConfiguration.pickListCode!
		);
		return (
			<Select
				value={selectValue}
				mode={dropDownConfiguration.mode}
				placeholder={dropDownConfiguration.placeholder!}
				disabled={dropDownConfiguration.disabled}
				labelInValue={dropDownConfiguration.labelInValue}
				className={dropDownConfiguration.className}
				optionFilterProp={dropDownConfiguration.optionFilterProps}
				onChange={onChange}
				// showSearch={true}
				// onSelect={props.onChange}
				// filterOption={(input, option) =>
				// 	option.props.children!.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
				// }
				// onSearch={(e: any) => props.onSearch!(e, options)}
			>
				{options}
			</Select>
		);
	}
};

const isUndefinedOrEmpty = (value: any) => {
	return value === undefined || value.length === 0;
};

const isUndefinedOrEmptyString = (value: any) => {
	return value === undefined || value === "";
};

const setValue = (
	value: any,
	pickListItems: PickListItemResponseDTO[],
	pickListCode: string
) => {
	if (Array.isArray(value)) {
		const selectValue = pickListItems
			.filter(
				(item: PickListItemResponseDTO) =>
					item.pickListTypeCode === pickListCode && value.includes(item.id!)
			)
			.map((foundVal: PickListItemResponseDTO) => ({
				key: foundVal.id!,
				label: foundVal.description!,
			}));
		return selectValue;
	}

	if (!isUndefinedOrEmpty(value) && !isUndefinedOrEmpty(pickListItems)) {
		const foundItem = pickListItems.find(
			(item: PickListItemResponseDTO) => item.id! === +value
		);
		const selectValue = { label: foundItem!.description! };
		return selectValue;
	} else {
		return;
	}
};

const filterSpecifiedOptions = (
	specifiedOptions: PickListItemResponseDTO[]
) => {
	return specifiedOptions
		.filter((o) => o.isActive)
		.map((item: PickListItemResponseDTO) => {
			return <Option key={item.id!.toString()}>{item.code}</Option>;
		});
};

const filterPickListItemsWithoutParentCode = (
	pickListItems: PickListItemResponseDTO[],
	pickListCode: string
) => {
	const filteredItems = pickListItems.filter(
		(item: PickListItemResponseDTO) => item.pickListTypeCode === pickListCode
	);
	if (!isUndefinedOrEmpty(filteredItems)) {
		const options = filteredItems.map((item) => (
			<Option key={item.id!.toString()}>{item.description!}</Option>
		));
		return options;
	}

	return [];
};

const filterPickListItemsByParentCode = (
	pickListItems: PickListItemResponseDTO[],
	parentCode: string,
	pickListCode: string
) => {
	const parentItem = pickListItems.find(
		(item: PickListItemResponseDTO) => item.code === parentCode
	);
	if (parentItem !== undefined) {
		const pickListItemsToChange = pickListItems.filter(
			(item: PickListItemResponseDTO) =>
				item.pickListTypeCode === pickListCode &&
				item.parentId === parentItem.id!
		);
		const options = pickListItemsToChange
			.sort((a, b) => a.description!.localeCompare(b.description!))
			.map((item) => (
				<Option key={item.id!.toString()}>{item.description!}</Option>
			));
		return options;
	}

	return [];
};
